import gql from 'graphql-tag';
import {
  GROUP_FRAGMENT,
  SUBJECT_FRAGMENT,
  TRACKER_FRAGMENT,
  SUBJECT_MEMBER_FRAGMENT
} from './fragments';

export const subjectDeleteMutation = gql`
  mutation SubjectDeleteMutation($id: ID!) {
    deleteSubject(id: $id) {
      errors {
        path
        message
      }
    }
  }
`;

export const createOrUpdateSubject = gql`
  mutation CreateOrUpdateSubject($input: CreateOrUpdateSubjectInput!) {
    createOrUpdateSubject(input: $input) {
      subject {
        ...SubjectFields
      }
      errors {
        path
        message
      }
    }
  }
  ${SUBJECT_FRAGMENT}
`;
export const subjectQuery = gql`
  query SubjectQuery($id: ID!) {
    subject(subjectId: $id) {
      ...SubjectFields
      groups {
        ...GroupFields
      }
      trackers {
        ...TrackerFields
      }
    }
  }
  ${SUBJECT_FRAGMENT}
  ${GROUP_FRAGMENT}
  ${TRACKER_FRAGMENT}
`;

export const subjectBySlugQuery = gql`
  query SubjectBySlugQuery($slug: String!, $notebookId: ID!) {
    subjectBySlug(slug: $slug, notebookId: $notebookId) {
      ...SubjectFields
      groups {
        ...GroupFields
      }
      trackers {
        ...TrackerFields
      }
    }
  }
  ${SUBJECT_FRAGMENT}
  ${GROUP_FRAGMENT}
  ${TRACKER_FRAGMENT}
`;

export const subjectTrackersQuery = gql`
  query SubjectTrackersQuery($id: ID!) {
    subject(subjectId: $id) {
      ...SubjectFields
      groups {
        trackers {
          id
          name
          slug
          type
        }
      }
      trackers {
        ...TrackerFields
      }
    }
  }
  ${SUBJECT_FRAGMENT}
  ${TRACKER_FRAGMENT}
`;

export const addMemberToSubjectMutation = gql`
  mutation AddMemberToSubjectMutation($input: AddMemberToSubjectInput!) {
    addMemberToSubject(input: $input) {
      subjectMember {
        ...SubjectMemberFields
      }
      errors {
        path
        message
      }
    }
  }
  ${SUBJECT_MEMBER_FRAGMENT}
`;

export const removeMemberFromSubjectMutation = gql`
  mutation RemoveMemberFromSubjectMutation($input: RemoveMemberFromSubjectInput!) {
    removeMemberFromSubject(input: $input) {
      subjectMember {
        ...SubjectMemberFields
      }
      errors {
        path
        message
      }
    }
  }
  ${SUBJECT_MEMBER_FRAGMENT}
`;

export const subjectMembersQuery = gql`
  query SubjectMembersQuery($input: SubjectMembersInput!) {
    subjectMembers(input: $input) {
      ...SubjectMemberFields
    }
  }
  ${SUBJECT_MEMBER_FRAGMENT}
`;

export const changeSubjectMembershipPermissions = gql`
  mutation ChangeSubjectMembershipPermissions($input: ChangeSubjectMembershipPermissionsInput!) {
    changeSubjectMembershipPermissions(input: $input) {
      subjectMember {
        id
        member {
          id
          displayName
          membershipStatus
          roleType
        }
      }
      errors {
        path
        message
      }
    }
  }
`;
